export default __webpack_public_path__ + "static/media/counterweight.2ee1f439.png";